import React from 'react';
import { Building2, Shield, Users, Award } from 'lucide-react';

const features = [
  {
    icon: Building2,
    title: 'Premium Locations',
    description: 'Strategically positioned developments in Egypt\'s most sought-after neighborhoods.'
  },
  {
    icon: Shield,
    title: 'Quality Assured',
    description: 'Uncompromising construction standards and premium materials in every project.'
  },
  {
    icon: Users,
    title: 'Dedicated Support',
    description: 'Personalized guidance from initial consultation to key handover.'
  },
  {
    icon: Award,
    title: 'Trusted Developer',
    description: 'A proven track record of delivering exceptional residential projects.'
  }
];

export const WhyChooseUs = () => {
  return (
    <section className="py-24 bg-stone-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-2xl mx-auto mb-16">
          <span className="inline-block text-xs font-semibold tracking-[0.2em] bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent uppercase mb-4">
            Why G Developments
          </span>
          <h2 className="text-3xl lg:text-4xl font-light text-stone-900 mb-6">
            Building Trust Through Excellence
          </h2>
          <p className="text-stone-500 leading-relaxed">
            We combine innovative design with meticulous craftsmanship to create homes that inspire and endure.
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => (
            <div
              key={feature.title}
              className="group p-8 bg-white border border-stone-100 hover:border-stone-200 transition-all duration-300 hover:shadow-lg"
            >
              {/* Icon */}
              <div className="w-12 h-12 flex items-center justify-center mb-6 bg-gradient-to-br from-blue-50 to-purple-50 text-blue-600 group-hover:from-blue-600 group-hover:to-purple-600 group-hover:text-white transition-all duration-300">
                <feature.icon size={24} strokeWidth={1.5} />
              </div>
              
              {/* Content */}
              <h3 className="text-lg font-medium text-stone-900 mb-3">
                {feature.title}
              </h3>
              <p className="text-sm text-stone-500 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
